var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinersclub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 24,
    rx: 2,
    fill: "#F5F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 -4H2V28H34V-4Z",
    fill: "#F5F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2465 22.2999C26.0053 22.3255 31.2615 17.9237 31.2615 12.5686C31.2615 6.71252 26.0053 2.66474 20.2465 2.66669H15.2905C9.46279 2.66474 4.66602 6.71373 4.66602 12.5686C4.66602 17.9248 9.46279 22.3256 15.2905 22.2999H20.2465Z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3135 3.47809C9.9883 3.47965 5.67313 7.50172 5.67188 12.4658C5.67313 17.4289 9.98826 21.4506 15.3135 21.4522C20.6399 21.4506 24.956 17.4289 24.9567 12.4658C24.9559 7.50172 20.6399 3.47965 15.3135 3.47809ZM9.20194 12.4658C9.20695 10.04 10.8328 7.97155 13.1254 7.14957V17.7807C10.8328 16.9592 9.20691 14.8918 9.20194 12.4658ZM17.5008 17.783V7.14922C19.7942 7.96922 21.4225 10.0389 21.4267 12.4658C21.4225 14.8934 19.7942 16.9615 17.5008 17.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2465 22.2999C26.0053 22.3255 31.2615 17.9237 31.2615 12.5686C31.2615 6.71252 26.0053 2.66474 20.2465 2.66669H15.2905C9.46279 2.66474 4.66602 6.71373 4.66602 12.5686C4.66602 17.9248 9.46279 22.3256 15.2905 22.2999H20.2465Z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3135 3.47809C9.9883 3.47965 5.67313 7.50172 5.67188 12.4658C5.67313 17.4289 9.98826 21.4506 15.3135 21.4522C20.6399 21.4506 24.956 17.4289 24.9567 12.4658C24.9559 7.50172 20.6399 3.47965 15.3135 3.47809ZM9.20194 12.4658C9.20695 10.04 10.8328 7.97155 13.1254 7.14957V17.7807C10.8328 16.9592 9.20691 14.8918 9.20194 12.4658ZM17.5008 17.783V7.14922C19.7942 7.96922 21.4225 10.0389 21.4267 12.4658C21.4225 14.8934 19.7942 16.9615 17.5008 17.783Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersclub);
export default __webpack_public_path__ + "static/media/dinersclub.129f2b70fe2c71daab33bbfc37e5aaab.svg";
export { ForwardRef as ReactComponent };